import { useCallback } from 'react';
import { clearStore } from 'services/idb-store';
import { clearOutbox } from 'services/outbox';
import { useGraphState } from 'components/GraphProvider';
import { useSwitchUserProfileMutation } from 'generated/graphql';
import useUser from './useUser';

export const useSwitchProfile = () => {
  const { resetClient } = useGraphState();
  const { onRefreshUser } = useUser();
  const [, switchProfile] = useSwitchUserProfileMutation();
  return useCallback(
    async (profileId: string) => {
      const response = await switchProfile({
        id: profileId,
      });
      if (response.error) {
        return response.error;
      } else {
        resetClient();
        await clearStore();
        // Queued changes were made as the previous profile; replaying them would act as this one.
        await clearOutbox();
        await onRefreshUser();
      }
    },
    [switchProfile, onRefreshUser, resetClient],
  );
};
